import { createAction } from '@ngrx/store';

export const enableBackdrop = createAction(
  '[Connect] Enable the cdk overlay backdrop',
);

export const disableBackdrop = createAction(
  '[Connect] Disable the cdk overlay backdrop',
);
